import { alpha } from '@mui/material';

import palette from '../theme/palette';

const globalStyles = {
  //scrollbar
  '*': {
    /* Firefox */
    scrollbarColor: alpha(palette.black, 0.1) + ' transparent',

    /* Chrome / Edge / Safari */
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(palette.black, 0.1)
    }
  },
  html: { height: '100%', width: '100%', overflow: 'auto' },
  body: {
    overflow: 'hidden',
    position: 'relative',
    height: 'auto',
    padding: 0,
    margin: 0,
    fontFamily: 'Reddit Sans, sans-serif, Roboto, Helvetica, Arial'
  },
  '#root': {
    backgroundColor: palette.globalBackground,
    height: '100dvh',
    width: '100%',
    overflow: 'hidden'
  }
};

export default globalStyles;
